import {feedbackAxios } from "@/config/axios";
import { UserFeedback } from "@/commons/interface/feedback/user-feedback";
import { AxiosResponse } from "axios";


export function getUserFeedbacks(params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/user-feedbacks`, {
        params: { ...params }
    })
}

export function createUserFeedback(data: UserFeedback, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/user-feedbacks`, data, {
        params: params
    })
}

export function updateUserFeedback(UserFeedbackId: number, data: UserFeedback, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.put(`/user-feedbacks/${UserFeedbackId}`, data, {
        params: params
    })
}

export function deleteUserFeedbacks(UserFeedbackIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/user-feedbacks/delete-multi`, UserFeedbackIds, {
        params: params
    })
}

export function getFeedbackFileUrl(objectName: string, bucketName: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/objects/url`, {
        params: {
            objectName: `${objectName}`,
            bucketName: `${bucketName}`,
            ...params,
        }
    })
}

export function checkFeedbackFileExists(md5: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/files/exists/${md5}`, {
        params: params,
    })
}

export function getFeedbackPresignedPutObjectUrl(objectName: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        },
    })
}